import { useTranslation } from "react-i18next";

import kioskIcon from "@assets/icons/svgr/kiosk.svg";
import posIcon from "@assets/icons/svgr/pos.svg";
import tabletIcon from "@assets/icons/svgr/tablet.svg";

import { Device, Step } from "@is/types";

import { TranslationContext } from "./i18n";

export enum RegistrationSteps {
  SelectStore = "SelectStore",
  SelectDevice = "SelectDevice",
  NameDevice = "NameDevice",
}

export enum DeviceType {
  Kiosk = "Kiosk",
  POS = "PointOfSales",
  Tablet = "Tablet",
}

export const REGISTRATION_STEPS: Step[] = [
  {
    key: RegistrationSteps.SelectStore,
  },
  {
    key: RegistrationSteps.SelectDevice,
  },
  {
    key: RegistrationSteps.NameDevice,
  },
];

export const DEVICES = () => {
  const { t } = useTranslation(TranslationContext.DeviceRegistration);

  return [
    {
      type: DeviceType.Kiosk,
      name: t("Kiosk"),
      description: t(
        "An interactive screen installed in store for customers and sales staff"
      ),
    },
    {
      type: DeviceType.POS,
      name: t("POS"),
      description: t(
        "A Point-Of-Sales device for sales staff to get payments from customers"
      ),
    },
    {
      type: DeviceType.Tablet,
      name: t("Tablet"),
      description: t("A portable and interactive device for sales staff"),
    },
  ] as Device[];
};

export const STEPS_TITLES = () => {
  const { t } = useTranslation(TranslationContext.DeviceRegistration);

  return {
    [RegistrationSteps.SelectStore]: t("Select your store"),
    [RegistrationSteps.SelectDevice]: t("Select device type"),
    [RegistrationSteps.NameDevice]: t("Name your device"),
  };
};

export enum RegistrationSortBy {
  StoreId = "StoreId",
  StoreName = "StoreName",
}

export const REGISTRATION_SORT_BY_OPTIONS = () => {
  const { t } = useTranslation(TranslationContext.DeviceRegistration);

  return [
    {
      value: RegistrationSortBy.StoreId,
      label: t("Store ID"),
    },
    {
      value: RegistrationSortBy.StoreName,
      label: t("Store name"),
    },
  ];
};

export const DEVICE_ICONS = {
  [DeviceType.Kiosk]: kioskIcon,
  [DeviceType.POS]: posIcon,
  [DeviceType.Tablet]: tabletIcon,
};
